import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DialogContentText, Typography } from "@material-ui/core";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {stopArchiveNotify} from "../firebaseApi";

const styles = (theme) => ({});

function InstructorArchiveDialog(props) {
  const [notifyStats, setNotifyStats] = React.useState({});
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [tabVal, setTabVal] = React.useState(1);

  React.useEffect(() => {
    if (props.archivedCourses.length !== 0) setTabVal(0);
  }, [props.archivedCourses]);

  React.useEffect(() => {
    let defaultNotifyStats = {};
    props.markedArchiveCourses.forEach((course) => {
      defaultNotifyStats[course.id] = false;
    });
    setNotifyStats(defaultNotifyStats);
  }, [props.markedArchiveCourses]);

  const turnoffNotify = (includeMarkedCourses) => {
    let stopNotify = [];

    for (const course of props.archivedCourses) {
      stopNotify.push(course.id);
    }

    if (includeMarkedCourses) {
      for (const id of Object.keys(notifyStats)) {

        if (notifyStats[id]) {
          stopNotify.push(id);
        }
      }
    }
    stopArchiveNotify({courses: stopNotify});
  };

	return (
		<>
      <Dialog 
        open={props.open} 
        onClose={() => {
          turnoffNotify(false);
          props.openCtl(false);
        }}
      >
        <DialogTitle>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          <Typography style={{ fontSize: "1.3rem" }} color="primary">
            Archive Notice
          </Typography>
          <IconButton
            style={{marginLeft: "auto"}}
            color="primary"
            // size="small"
            onClick={() => {
              setDialogOpen(true);
            }}
          >
            <InfoOutlinedIcon />
          </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          {props.archivedCourses.length !== 0 && props.markedArchiveCourses.length !== 0 &&
            <Tabs
              value={tabVal}
              style={{
                marginBottom: 20,
              }}
              onChange={(event, newVal) => {
                setTabVal(newVal);
              }}  
            >
              <Tab label="Archived"/>
              <Tab label="Marked for Archiving"/>
            </Tabs>
          }
          
          {tabVal === 0 && 
            <>
            <DialogContentText>
              This is a one-time notice that the following courses have been archived.
              For more information on archiving, please see the info button above.
              {/* <IconButton
                style={{marginLeft: 5}}
                color="primary"
                size="small"
                onClick={() => {
                  setDialogOpen(true);
                }}
              >
                <InfoOutlinedIcon />
              </IconButton> */}
            </DialogContentText>
            <TableContainer sx={{  marginTop: "25px", marginBottom: "25px" }} component={Paper}>
              <Table aria-label="archive-notice">
                <TableHead >
                  <TableRow>
                    <TableCell>Course</TableCell>
                    <TableCell>Term</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.archivedCourses.map((course) => 
                    <TableRow
                      key={course.id}
                    >
                      <TableCell>
                        {course.name}
                      </TableCell>
                      <TableCell>
                        {course.term}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            </>
          }
          {tabVal === 1 && 
            <>
            <DialogContentText>
              The following courses have been marked as inactive and will eventually be archived. If you believe 
              this is a mistake, please contact Curt Schurgers (<Link href="mailto:cschurgers@ucsd.edu">cschurgers@ucsd.edu</Link>).
              For more information on archiving, please see the info button above.
            </DialogContentText>
            <TableContainer sx={{  marginTop: "25px", marginBottom: "25px" }} component={Paper}>
              <Table aria-label="archive-notice">
                <TableHead >
                  <TableRow>
                    <TableCell align="left">Course</TableCell>
                    <TableCell align="left">Term</TableCell>
                    <TableCell align="right">Don't Remind Again</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.markedArchiveCourses.map((course) => 
                    <TableRow
                      key={course.id}
                    >
                      <TableCell align="left">
                        {course.name}
                      </TableCell>
                      <TableCell align="left">
                        {course.term}
                      </TableCell>
                      <TableCell align="right">
                        <Checkbox
                          checked={notifyStats[course.id] ?? false}
                          onChange={(event) => {
                            let newNotifyStats = {...notifyStats}
                            newNotifyStats[course.id] = event.target.checked;
                            setNotifyStats(newNotifyStats);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            </>
          }
        </DialogContent>
        <Dialog
          open={dialogOpen}
          onClose={() => {
            setDialogOpen(false);
          }}
        >
          <DialogTitle>
            <Typography style={{ fontSize: "1.3rem" }} color="primary">
              How does archiving work?
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography>
              When a course is archived, it is moved from your list of active courses to the inactive courses dropdown in the sidebar; 
              for students, the course will no longer appear in their sidebar. All data associated with an archived 
              course is preserved and remains fully accessible. 
            </Typography>
          </DialogContent>
          <DialogActions style={{justifyContent: "center"}}>
            <Button
              onClick={() => {
                setDialogOpen(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <DialogActions
          style={{justifyContent: "center"}}
        >
          <Button 
            color="primary" 
            onClick={() => {
              turnoffNotify(true);
              props.openCtl(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
		</>
	);
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(InstructorArchiveDialog))));
